var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMargarita(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 10.6875C17.5508 10.6875 19.0625 9.17578 19.0625 7.3125C19.0625 5.44922 17.5508 3.9375 15.6875 3.9375C14.4219 3.9375 13.332 4.64062 12.7344 5.625H10.9062C11.6094 3.69141 13.4727 2.25 15.6875 2.25C18.4648 2.25 20.75 4.53516 20.75 7.3125C20.75 10.125 18.4648 12.375 15.6875 12.375C14.7031 12.375 13.7891 12.1289 13.0156 11.6367L14.2461 10.4062C14.7031 10.582 15.1602 10.6875 15.6875 10.6875ZM0.535156 7.27734C0.675781 6.96094 0.992188 6.75 1.34375 6.75H14.2812C14.5977 6.75 14.9141 6.96094 15.0547 7.27734C15.1602 7.59375 15.0898 7.98047 14.8789 8.19141L8.65625 14.4141V18.5625H10.9062C11.3633 18.5625 11.75 18.9492 11.75 19.4062C11.75 19.8984 11.3633 20.25 10.9062 20.25H7.8125H4.71875C4.22656 20.25 3.875 19.8984 3.875 19.4062C3.875 18.9492 4.22656 18.5625 4.71875 18.5625H6.96875V14.4141L0.746094 8.19141C0.5 7.98047 0.429688 7.59375 0.535156 7.27734Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMargarita);
export default ForwardRef;